export default {
  // 登录
  login: 'views/Login/Login',
  index: 'layouts/MenuView',
  // 异常
  callback: 'views/Exception/Callback',
  error: 'views/Exception/Error',
  notFound: 'views/Exception/NotFound',
  //
  authority: 'views/Exception/Authority',
  // 工作台
  workplaceIndex: 'views/WorkPlace/Index',
  workplaceWorkflow: 'views/WorkPlace/Workflow',
  // 站内信
  inMail: 'views/InMail/Index',
  // 内容管理
  contentIndex: 'views/Content/Index',
  contentCreate: 'views/Content/Create',
  contentDetail: 'views/Content/Detail',
  wechatPublicEdit: 'views/Content/components/WechatPublicEdit',
  sinaWeiboEdit: 'views/Content/components/SinaWeiboEdit',
  // 栏目管理
  columnIndex: 'views/Column/Index',
  columnPermission: 'views/Column/Permission',
  docPermission: 'views/Column/DocPermission',
  // 配置
  // 站点管理
  configSiteIndex: 'views/Config/Site/Index',
  configSiteDetail: 'views/Config/Site/Detail',
  configSitePermissionSite: 'views/Config/Site/Permission/Site',
  configSitePermissionSiteGroup: 'views/Config/Site/Permission/SiteGroup',
  configSiteStatic: 'views/Config/Site/Static',
  // 模板管理
  configTemplateseIndex: 'views/Config/Templates/Index',
  configTemplatesDetail: 'views/Config/Templates/Detail',
  // 文件管理
  configFilesIndex: 'views/Config/Files/Index',
  configFilesDetail: 'views/Config/Files/Detail',
  // 消息管理
  configInformationIndex: 'views/Config/Information/Index',
  configInformationDetail: 'views/Config/Information/Detail',
  // 词汇管理
  configVocabularyTag: 'views/Config/Vocabulary/Tag/Index',
  configVocabularySensitive: 'views/Config/Vocabulary/Sensitive/Index',
  configVocabularySearch: 'views/Config/Vocabulary/Search/Index',
  configVocabularyHotIndex: 'views/Config/Vocabulary/Hot/Index',
  configVocabularyHotDetail: 'views/Config/Vocabulary/Hot/Detail',
  configVocabularyHotManage: 'views/Config/Vocabulary/Hot/HotManage/Index',
  // 来源管理
  configVocabularySource: 'views/Config/Vocabulary/Source/Index',
  // 内容类型管理
  configVocabularyContent: 'views/Config/Vocabulary/Content/Index',
  // 发文字号管理
  configVocabularyFontsize: 'views/Config/Vocabulary/Fontsize/Index',
  // 内容索引
  configContent: 'views/Config/Content/Index',
  // 定时任务
  configTiming: 'views/Config/Timing/Index',
  // 工作流
  configWorkflowIndex: 'views/Config/Workflow/Index',
  configWorkflowCreate: 'views/Config/Workflow/Create',
  configWorkflowDetail: 'views/Config/Workflow/Detail',
  // 内容智能审核
  configAuditManage: 'views/Config/Audit/Manage/Index',
  configAuditColumnSetting: 'views/Config/Audit/ColumnSetting/Index',
  configAuditModelSetting: 'views/Config/Audit/ModelSetting/Index',
  // 网站统计
  statisticsGeneral: 'views/Statistics/General/Index',
  statisticsFlowIndex: 'views/Statistics/Flow/Index',
  statisticsFlowTendency: 'views/Statistics/Flow/Tendency',
  // 来源分析
  statisticsSourceIndex: 'views/Statistics/Source/Index',
  statisticsSourceSearch: 'views/Statistics/Source/Search',
  statisticsSourceLink: 'views/Statistics/Source/Link',
  // 受访分析
  statisticsInterviewerIndex: 'views/Statistics/Interviewer/Index',
  statisticsInterviewerEntrance: 'views/Statistics/Interviewer/Entrance',
  // 访客分析
  statisticsVisitorTerritory: 'views/Statistics/Visitor/Territory',
  statisticsVisitorNetwork: 'views/Statistics/Visitor/Network',
  statisticsVisitorVisitor: 'views/Statistics/Visitor/Visitor',
  statisticsVisitorFidelity: 'views/Statistics/Visitor/Fidelity',
  // 内容发布-栏目
  statisticsReleaseColumns: 'views/Statistics/Release/Column',
  // 内容发布-用户
  statisticsReleaseUser: 'views/Statistics/Release/User',
  // 内容发布-组织
  statisticsReleaseOrganization: 'views/Statistics/Release/organization',
  // 内容发布-站点
  statisticsReleaseSiteview: 'views/Statistics/Release/Siteview',
  // 内容数据统计-栏目
  statisticsInformationIndex: 'views/Statistics/Information/index',
  // 内容数据统计-单片内容
  statisticsInformationSingle: 'views/Statistics/Information/Single',
  // 互动
  // 评论管理
  interactCommentIndex: 'views/Interact/Comment/Index',
  interactCommentContent: 'views/Interact/Comment/Content',
  interactCommentMember: 'views/Interact/Comment/Member',
  interactCommentIp: 'views/Interact/Comment/Ip',
  interactCommentForbidIndex: 'views/Interact/Comment/Forbid/Index',
  interactCommentForbidMember: 'views/Interact/Comment/Forbid/Member',
  interactCommentForbidIp: 'views/Interact/Comment/Forbid/Ip',
  interactCommentReport: 'views/Interact/Comment/Report',
  // 采集管理
  interactCollectIndex: 'views/Interact/Collect/Index',
  interactCollectIframe: 'views/Interact/Collect/CollectIframe',
  interactCollectCreateFast: 'views/Interact/Collect/CreateFast',
  interactCollectCreateCustom: 'views/Interact/Collect/CreateCustom',
  interactCollectDetail: 'views/Interact/Collect/Detail',
  // 友情链接
  interactBlogrollIndex: 'views/Interact/Blogroll/Index',
  interactBlogrollDetail: 'views/Interact/Blogroll/Detail',
  // 投票调查
  interactVoteIndex: 'views/Interact/Vote/Index',
  interactVoteCreate: 'views/Interact/Vote/Create',
  interactVoteDetail: 'views/Interact/Vote/Detail',
  interactVoteView: 'views/Interact/Vote/View',
  // 智能表单
  interactSmartIndex: 'views/Interact/Smart/Index',
  interactSmartDetail: 'views/Interact/Smart/Detail',
  interactSmartView: 'views/Interact/Smart/View',
  // 领导信箱
  interactLetterFormIndex: 'views/Interact/Letter/Form/Index',
  interactLetterFormDetail: 'views/Interact/Letter/Form/Detail',
  interactLetterTypeIndex: 'views/Interact/Letter/Type/Index',
  interactLetterBoxIndex: 'views/Interact/Letter/Box/Index',
  interactLetterMyIndex: 'views/Interact/Letter/My/Index',
  // 你问我答
  interactQueAndAnsIndex: 'views/Interact/QueAndAns/Index',
  interactAnsList: 'views/Interact/QueAndAns/components/AnsList',
  // 社交媒体
  // 微信
  socialWechatAuthorizationIndex: 'views/Social/Wechat/Authorization/Index',
  socialWechatPublicDetail: 'views/Social/Wechat/Authorization/PublicDetail',
  socialWechatAppletDetail: 'views/Social/Wechat/Authorization/AppletDetail',
  socialWechatMenuIndex: 'views/Social/Wechat/Menu/Index',
  socialWechatMenuDefaultDetail: 'views/Social/Wechat/Menu/DefaultDetail',
  socialWechatIndividualizationDetail: 'views/Social/Wechat/Menu/IndividualizationDetail',
  socialWechatMenuDefaultAdd: 'views/Social/Wechat/Menu/DefaultAdd',
  socialWechatIndividualizationAdd: 'views/Social/Wechat/Menu/IndividualizationAdd',
  socialWechatMaterialIndex: 'views/Social/Wechat/Material/Index',
  socialWechatMaterialImageTextAdd: 'views/Social/Wechat/Material/Material/ImageTextAdd',
  socialWechatMaterialImageTextEdit: 'views/Social/Wechat/Material/Material/ImageTextEdit',
  socialWechatAutoReply: 'views/Social/Wechat/AutoReply/Index',
  socialWechatFansIndex: 'views/Social/Wechat/Fans/Index',
  socialWechatFansSend: 'views/Social/Wechat/Fans/SendMessage',
  socialWechatComment: 'views/Social/Wechat/Comment/Index',
  socialWechatMessage: 'views/Social/Wechat/Message/Index',
  socialWechatPushIndex: 'views/Social/Wechat/Push/Index',
  socialWechatPushDetail: 'views/Social/Wechat/Push/Detail',
  socialWechatFansStatistics: 'views/Social/Wechat/FansStatistics/Index',
  socialWechatGroup: 'views/Social/Wechat/GroupSend/Index',
  socialWechatStatistics: 'views/Social/Wechat/Statistics/Index',
  socialWechatApplet: 'views/Social/Wechat/Applet/Index',
  // 微博
  socialWeiboApplication: 'views/Social/Weibo/Application/Index',
  socialWeiboAccount: 'views/Social/Weibo/Account/Index',
  socialWeiboFans: 'views/Social/Weibo/Fans/Index',
  socialWeiboMessage: 'views/Social/Weibo/Message/Index',
  socialWeiboPushRecord: 'views/Social/Weibo/PushRecord/Index',
  // 会员
  // 待审核会员
  vipCheckPendingIndex: 'views/VIP/CheckPending/Index',
  vipCheckPendingDetail: 'views/VIP/Member/Detail',
  // 会员管理
  vipMemberIndex: 'views/VIP/Member/Index',
  vipMemberDetail: 'views/VIP/Member/Detail',
  vipMemberCreate: 'views/VIP/Member/Create',
  // 会员组管理
  vipGroupNameIndex: 'views/VIP/GroupName/Index',
  vipGroupNameDetail: 'views/VIP/GroupName/Detail',
  vipGroupNameMembersIndex: 'views/VIP/GroupName/Members/Index',
  // 会员等级
  vipGrade: 'views/VIP/Grade/Index',
  // 积分配置
  vipIntegral: 'views/VIP/Integral/Index',
  // 系统
  // 组织管理
  organizeIndex: 'views/System/Organize/Index',
  organizeMember: 'views/System/Organize/Member',
  organizeDetail: 'views/System/Organize/Detail',
  organizePermission: 'views/System/Organize/Permission',
  // 角色管理
  roleIndex: 'views/System/Role/Index',
  roleEdit: 'views/System/Role/Edit',
  roleMember: 'views/System/Role/Membership',
  rolePermission: 'views/System/Role/Permission',
  // 用户管理
  userIndex: 'views/System/User/Index',
  userCreate: 'views/System/User/Create',
  userPermission: 'views/System/User/Permission',
  // 模型管理
  modelColumnIndex: 'views/System/Model/Column/Index',
  modelColumnDetail: 'views/System/Model/Column/Detail',
  modelContentIndex: 'views/System/Model/Content/Index',
  modelContentDetail: 'views/System/Model/Content/Detail',
  modelNewContentDetail: 'views/System/Model/NewContent/Detail',
  modelVip: 'views/System/Model/Vip/Detail',
  // 资源库
  resource: 'views/System/Resource/Index',
  // 系统设置
  systemSetting: 'views/System/SystemSetting/Index',
  singleLoginSetting: 'views/System/SingleLogin/Index',
  // 账户安全设置
  safe: 'views/System/Safe/Index',
  // 密级管理
  securityUserIndex: 'views/System/Security/User/Index',
  securityUserDetail: 'views/System/Security/User/Detail',
  securityContentIndex: 'views/System/Security/Content/Index',
  securityContentDetail: 'views/System/Security/Content/Detail',
  securityAccessoryIndex: 'views/System/Security/Accessory/Index',
  securityAccessoryDetail: 'views/System/Security/Accessory/Detail',
  // 存储管理
  storageFtpIndex: 'views/System/Storage/FtpStorge/Index',
  storageFtpDetail: 'views/System/Storage/FtpStorge/Detail',
  storageCloudIndex: 'views/System/Storage/CloudStorage/Index',
  storageCloudDetail: 'views/System/Storage/CloudStorage/Detail',
  // 第三方登录设置
  thirdParty: 'views/System/ThirdParty/Index',
  // 短信服务设置
  sms: 'views/System/SMS/Index',
  // 邮件服务设置
  email: 'views/System/Email/Index',
  // 微信开放平台设置
  weixin: 'views/System/Weixin/Index',
  // 防火墙设置
  firewall: 'views/System/Firewall/Index',
  // 数据备份
  backup: 'views/System/Backup/Index',
  // 日志管理
  logRealTime: 'views/System/Log/RealTime/Index',
  logSystem: 'views/System/Log/System/Index',
  logBusiness: 'views/System/Log/Business/Index',
  logAudit: 'views/System/Log/Audit/Index',
  logSafety: 'views/System/Log/Safety/Index',
  logReport: 'views/System/Log/Report/Index',
  logBackups: 'views/System/Log/Backups/Index',
  logStrategy: 'views/System/Log/Strategy/Index',
  logStatistics: 'views/System/Log/Statistics/Index',
  // 菜单管理
  menusApisIndex: 'views/System/Menus/Apis/Index',
  menusApisDetail: 'views/System/Menus/Apis/Detail',
  menusMenusIndex: 'views/System/Menus/Menus/Index',
  menusMenusDetail: 'views/System/Menus/Menus/Detail',
  menusMenusCreate: 'views/System/Menus/Menus/Create',
  // 系统信息
  systemInfo: 'views/System/SystemInfo/Index',
  // 区域管理
  district: 'views/System/District/Index',
  // 三员管理设置
  threeMemberSetting: 'views/System/ThreeMember/Setting/Index',
  // 三员审核
  threeMemberAudit: 'views/System/ThreeMember/Audit/Index',
  // 三员审核日志
  threeMemberJournal: 'views/System/ThreeMember/Journal/Index',
  // 双因子
  doubleIndex: 'views/System/Double/Index',
  // 绩效管理
  performanceIndex: 'views/System/Performance/Index',
  // 绩效管理-新增
  performanceAdd: 'views/System/Performance/Add',
  // 绩效管理-详情
  performanceDetail: 'views/System/Performance/Detail',
  // 绩效管理-结果列表
  performanceList: 'views/System/Performance/List/Index',
  // 绩效管理-查看绩效列表 performanceExamineDetail
  performanceExamine: 'views/System/Performance/Examine/Index',
  // 绩效管理-查看绩效详情
  performanceExamineDetail: 'views/System/Performance/Examine/Detail',
  // 分级保护-设置
  hierarchicalSettin: 'views/System/Hierarchical/Settin/Index',
  // 分级保护-用户密级设置
  hierarchicalSecret: 'views/System/Hierarchical/Secret/Index',
  // 分级保护-用户日志
  hierarchicalJournal: 'views/System/Hierarchical/Journal/Index',
  // 服务市场
  serviceIndex: 'views/Service/Index'
}
